module.exports = __webpack_public_path__ + "static/media/OGG-tablet-showcase-2.5598690c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images_hd/Ogg/OGG-tablet-showcase-2.jpg
// module id = 621
// module chunks = 0